import { formatDateTime } from '@clatter/platform';
import { parseSearchInput } from './parsers';
import { GridApi, GridColDef, GridFilterItem, GridLogicOperator } from '@mui/x-data-grid-premium';

export const nameColumn: GridColDef = {
  field: 'name',
  headerName: 'Name',
  flex: 0.5,
};

export const displayNameColumn: GridColDef = {
  field: 'DisplayName',
  headerName: 'Display Name',
  flex: 0.5,
};

export const emailColumn: GridColDef = {
  field: 'email',
  headerName: 'Email',
  flex: 0.5,
};

export const countColumn: GridColDef = {
  field: 'Count',
  headerName: 'Count',
  type: 'number',
  flex: 0.1,
};

export const createdAtColumn: GridColDef = {
  field: 'createdAt',
  headerName: 'Created',
  flex: 0.3,
  type: 'date',
  valueFormatter: (value) => value ? formatDateTime(value) : null,
  // valueGetter: (value, row) => (value ? new Date(value) : null),
};

export const updatedAtColumn: GridColDef = {
  field: 'updatedAt',
  headerName: 'Updated',
  type: 'date',
  flex: 0.3,
  valueFormatter: (value) => value ? formatDateTime(value) : null,
  // valueGetter: (value, row) => (value ? new Date(value) : null),
};

export const dataGridCommonColumns: GridColDef[] = [nameColumn, createdAtColumn, updatedAtColumn];

export const setFiltersBasedOnInput = (
  input: string,
  apiRef: React.MutableRefObject<GridApi | null>,
  slice?: number,
) => {
  if (!apiRef?.current || !apiRef?.current?.setFilterModel) return;

  const filterValues: string[] = parseSearchInput(input);

  if (filterValues.length === 0) {
    apiRef.current.setFilterModel({ items: [] });
    return;
  }

  const allFields = apiRef.current
    .getAllColumns()
    .filter((col) => col.filterable !== false && col.field !== '__check__')
    .map((col) => col.field);

  const searchableFields = slice != null ? allFields.slice(0, slice) : allFields;

  if (searchableFields.length === 0) return;

  const filterItems: GridFilterItem[] = [];

  filterValues.forEach((value, vi) => {
    searchableFields.forEach((field, fi) => {
      filterItems.push({
        id: `filter-${field}-${vi}-${fi}`,
        field: field,
        operator: 'contains',
        value,
      });
    });
  });

  apiRef.current.setFilterModel({
    items: filterItems,
    logicOperator: GridLogicOperator.Or,
  });
};
